import {
  useBlockProps,
  MediaUpload,
  MediaUploadCheck
} from '@wordpress/block-editor'
import { Button } from '@wordpress/components'
import { __ } from '@wordpress/i18n'

export default function Edit ({ attributes, setAttributes }) {
  const { images } = attributes
  const blockProps = useBlockProps({
    className: 'coziehomes-gallery-slider'
  })

  const onSelectImages = media => {
    setAttributes({
      images: media.map(image => ({
        id: image.id,
        url: image.url,
        alt: image.alt || ''
      }))
    })
  }

  const onRemoveImage = id => {
    setAttributes({
      images: images.filter(img => img.id !== id)
    })
  }

  return (
    <div {...blockProps}>
      <MediaUploadCheck>
        <MediaUpload
          onSelect={onSelectImages}
          allowedTypes={['image']}
          multiple
          gallery
          value={images.map(img => img.id)}
          render={({ open }) => (
            <div className='coziehomes-gallery-slider__editor'>
              {images.length > 0 && (
                <div className='coziehomes-gallery-slider__grid'>
                  {images.map(img => (
                    <div
                      key={img.id}
                      className='coziehomes-gallery-slider__item aspect_ratio ratio_hdv'
                    >
                      <img src={img.url} alt={img.alt} />
                      <Button
                        onClick={() => onRemoveImage(img.id)}
                        isDestructive
                        size='small'
                        variant='secondary'
                        className='coziehomes-gallery-slider__remove-btn'
                      >
                        {__('Remove', 'coziehomes')}
                      </Button>
                    </div>
                  ))}
                </div>
              )}
              <Button
                onClick={open}
                size='small'
                variant='primary'
                className='coziehomes-gallery-slider__upload-btn'
              >
                {images.length > 0
                  ? __('Edit Gallery', 'coziehomes')
                  : __('Select Images', 'coziehomes')}
              </Button>
            </div>
          )}
        />
      </MediaUploadCheck>
    </div>
  )
}
